const PerformanceSection = () => {
  const comparisons = [
    { name: "NETIUS", lcp: 0.8, color: "bg-primary" },
    { name: "WordPress", lcp: 3.2, color: "bg-muted-foreground/50" },
    { name: "Wix", lcp: 4.1, color: "bg-muted-foreground/50" },
    { name: "Squarespace", lcp: 3.8, color: "bg-muted-foreground/50" },
  ];

  const maxLcp = 5;

  return (
    <section className="py-16 border-t border-border" aria-labelledby="performance-title">
      <div className="container px-4 sm:px-6 lg:px-8">
        <div className="max-w-3xl mx-auto">
          <div className="text-center mb-12 animate-fade-in">
            <h2 id="performance-title" className="text-3xl md:text-4xl font-bold mb-4">
              Faster by Design
            </h2>
            <p className="text-muted-foreground text-lg">
              LCP (Largest Contentful Paint) comparison. Lower is better.
            </p>
          </div>

          <div className="space-y-4">
            {comparisons.map((item, index) => (
              <div
                key={index}
                className="animate-fade-in"
                style={{ animationDelay: `${index * 100}ms` }}
              >
                <div className="flex justify-between mb-2">
                  <span className="font-medium">{item.name}</span>
                  <span className="text-muted-foreground">{item.lcp}s</span>
                </div>
                <div className="h-4 bg-secondary rounded-full overflow-hidden">
                  <div
                    className={`h-full ${item.color} rounded-full transition-all duration-1000`}
                    style={{ width: `${(item.lcp / maxLcp) * 100}%` }}
                  />
                </div>
              </div>
            ))}
          </div>

          <p className="text-center text-sm text-muted-foreground mt-8">
            *Based on average performance metrics. Your results may vary based on content and configuration.
          </p>
        </div>
      </div>
    </section>
  );
};

export default PerformanceSection;
